import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

const defaultPadding = '1.125rem 1.125rem 0';

export const LocationProfile = styled.div.attrs({
  className: 'LocationProfile',
})`
  .Title {
    font-size: 1.625rem;
    margin-bottom: 0;
    line-height: 2rem;
    color: ${themed('primary.main')};
    margin-bottom: 0.25rem;
    padding: ${defaultPadding};
  }

  .modal__dialog {
    padding: 1.75rem 0;
  }
`;

export const ErrorWrapper = styled.div`
  padding: ${defaultPadding};
`;

export const Textwrapper = styled.div`
  .Text {
    color: ${themed('primary.main')};
    font-size: 0.875rem;
    padding: ${defaultPadding};
  }
`;

export const Location = styled.div.attrs({
  className: 'Location',
})`
  display: flex;
  gap: 0.875rem;
  padding: ${defaultPadding};

  & + & {
    border-top: 2px solid #E9ECED;
  }
  `;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    .Text {
      color: ${themed('primary.main')};
      font-size: 0.875rem;
      margin-bottom: 0.375rem;
    }

    .Text:first-letter {
      text-transform: capitalize;
    }

    & > .Title {
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.75rem;
      line-height: 1.125rem;
      letter-spacing: 0.125rem;
      margin-bottom: 0.25rem;
      color: ${themed('primary.main')};
      padding: unset;
    }
`;

export const ButtonWrapper = styled.div`
  padding: ${defaultPadding};
`;
